import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { promotionKeys, type PromotionFilters } from "./query-keys";

export function usePromotions(filters?: PromotionFilters) {
  return useQuery({
    queryKey: promotionKeys.promotions(filters),
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/v1/promotions", {
        params: { query: filters ?? {} },
      });
      /* v8 ignore next -- unreachable: client errorMiddleware throws ApiError on !ok */
      if (error) throw error;
      return data;
    },
    staleTime: 30_000,
  });
}
